import { clienteAxios, updateHeader } from "../config/axios"
import { history } from "../helpers/history"
import axios from "./axios"
import { authHeader } from "../helpers/auth-header"
import { clearLocalStorage } from "../utils"

const getSourcesList = async () => {
	return await axios.post(`/info/metadata/source`).then((data) => {
		return data
	})
}

const getEmailsList = async (emailType) => {
	return await axios.post(`/info/metadata/${emailType}`).then((data) => {
		return data
	})
}

const getUserList = async () => {
	return await axios.get(`/info/users`).then((data) => {
		return data
	})
}

const getRetainFilterListFromJob = async (id) => {
	return await axios.get(`/job/${id}`).then((data) => {
		return data
	})
}

const getInfo = async () => {
	return await axios.get(`/info`).then((data) => {
		return data
	})
}

const getReviewOverview = async (payload) => {
	return await axios.post(`/info/reviews/dashboard`, payload).then((data) => {
		return data
	})
}

const getUserReviewOverview = async (payload) => {
	return await axios.post(`/info/reviews/dashboard/${payload?.id}?is_table=${payload?.data?.is_table}`).then((data) => {
		return data
	})
}

const getDynamicEmailsList = async (payload, emailType) => {
	return await axios.post(`/info/elastic-metadata/${emailType}`, payload).then((data) => {
		return data
	})
}

export const infoService = {
	getEmailsList,
	getUserList,
	getSourcesList,
	getRetainFilterListFromJob,
	getInfo,
	getReviewOverview,
	getUserReviewOverview,
	getDynamicEmailsList,
}
